import { FileText, HardDrive, Layers } from "lucide-react";
import type { RagCollection } from "../../services/rag";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

interface RagStatsProps {
	collection: RagCollection;
}

export function RagStats({ collection }: RagStatsProps) {
	const totalSizeMB = Number(collection.totalSizeBytes) / (1024 * 1024);

	return (
		<div className="grid gap-4 md:grid-cols-3">
			<Card>
				<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
					<CardTitle className="text-sm font-medium">Documents</CardTitle>
					<FileText className="h-4 w-4 text-muted-foreground" />
				</CardHeader>
				<CardContent>
					<div className="text-2xl font-bold">{collection.documentCount}</div>
					<p className="text-xs text-muted-foreground">Total documents</p>
				</CardContent>
			</Card>

			<Card>
				<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
					<CardTitle className="text-sm font-medium">Chunks</CardTitle>
					<Layers className="h-4 w-4 text-muted-foreground" />
				</CardHeader>
				<CardContent>
					<div className="text-2xl font-bold">
						{collection.totalChunks.toLocaleString()}
					</div>
					<p className="text-xs text-muted-foreground">Total chunks</p>
				</CardContent>
			</Card>

			<Card>
				<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
					<CardTitle className="text-sm font-medium">Size</CardTitle>
					<HardDrive className="h-4 w-4 text-muted-foreground" />
				</CardHeader>
				<CardContent>
					<div className="text-2xl font-bold">{totalSizeMB.toFixed(2)} MB</div>
					<p className="text-xs text-muted-foreground">Total size</p>
				</CardContent>
			</Card>
		</div>
	);
}
